export const DEFAULT_TERYT_SYM_UL = 99999

export const SOURCE = 1  // source - landing page
export const CONTACT_TYPE_PHONE = 0
export const CONTACT_TYPE_EMAIL = 1